import { Component, Input } from '@angular/core'
import { Sku } from '../../../../models'

@Component({
  selector: 'app-sku-snippet-com',
  templateUrl: './sku-snippet.com.html'
})

export class SkuSnippetComponent {

  @Input() sku: Sku = null
  @Input() terse = true
  @Input() split = false

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/holders/sku-snippet/sku-snippet.com.ts